import * as React from 'react';
import { Button, Text, createStyles, useMantineTheme } from '@mantine/core';
import { IconFilter } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';

const useStyles = createStyles((theme) => ({
    button: {
        paddingRight: '8px'
    },
    counter: {
        background: theme.colors.blue[6],
        borderRadius: '50%',
        marginLeft: '8px',
        height: '1.3rem',
        width: '1.3rem',
        display: 'flex',
        justifyContent: 'center',
        color: '#fff',
        alignItems: 'center'
    },
    invisible: {
        opacity: 0
    }
}));

interface ClearAllFiltersButtonProps {
    resetColumnFilters: (defaultState?: boolean | undefined) => void;
    resetGlobalFilter: (defaultState?: boolean | undefined) => void;
    className?: string;
    filterCount?: number;
}

export const ClearAllFiltersButton: React.FC<ClearAllFiltersButtonProps> = ({
    className = '',
    resetGlobalFilter,
    resetColumnFilters,
    filterCount
}) => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation('components', { keyPrefix: 'tables.common' });
    const theme = useMantineTheme();

    return (
        <Button
            className={cx(classes.button, {
                [className]: className
            })}
            leftIcon={<IconFilter size={14} color={filterCount ? theme.colors.blue[6] : undefined} />}
            variant="default"
            onClick={() => {
                resetColumnFilters();
                resetGlobalFilter();
            }}
        >
            <Text>{t('clearFilters')}</Text>
            <div
                className={cx(classes.counter, {
                    [classes.invisible]: !filterCount
                })}
            >
                {filterCount}
            </div>
        </Button>
    );
};
